import { render, staticRenderFns } from "./MagicChildrenRowOps.vue?vue&type=template&id=1a4be276&scoped=true"
import script from "./MagicChildrenRowOps.vue?vue&type=script&lang=ts"
export * from "./MagicChildrenRowOps.vue?vue&type=script&lang=ts"
import style0 from "./MagicChildrenRowOps.vue?vue&type=style&index=0&id=1a4be276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4be276",
  null
  
)

export default component.exports